import {
  EDisbursementMethod,
  EEmploymentStatus,
  EPaySchedule,
  schemes,
  zSchema,
} from "@zeal/common";

export const getPayrollRunEmployeesRequestSchema = zSchema.object({
  disbursement_method: zSchema.nativeEnum(EDisbursementMethod).optional(),
  // pay_schedule: zSchema.nativeEnum(EPaySchedule).optional(),
  pay_schedule: zSchema.string().optional(),
  payroll_run_id: schemes.mongoObjectId(),
  regular_only: zSchema.boolean().optional(),
});

export type TGetPayrollRunEmployeesRequest = zSchema.infer<
  typeof getPayrollRunEmployeesRequestSchema
>;

export const getPayrollRunEmployeesResponseSchema = zSchema.object({
  _id: zSchema.string(),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
  default_pay_schedule: zSchema.nativeEnum(EPaySchedule),
  employment_status: zSchema.nativeEnum(EEmploymentStatus),
  onboarded: zSchema.boolean(),
});

export type TGetPayrollRunEmployeesResponse = zSchema.infer<
  typeof getPayrollRunEmployeesResponseSchema
>;
